import * as axiosBase from '@/api/index.js';

// 查询周报数据
export let queryWeekDate = function(params) {
  return axiosBase.GET("/jcring/newDataset/generalWeekReport", params)
}

// 查询月报数据
export let queryMonthDate = function(params) {
  return axiosBase.GET("/jcring/newDataset/generalMonthReport", params)
}




// WEBPACK FOOTER //
// ./src/api/JCRingAI/AI.js